<template>
  <div class="container container-global">
    <h2>Fiches Informations</h2>
    <div class="cadre-container">
      <div class="cadre">
        <div @click="toggleCadre1()" class="title">
          <p>Contraception orale</p>
          <a class="next">
            <img v-if="!cadre1" :src="Right" alt="" /><img
              v-else
              :src="Arrow"
              alt=""
            />
          </a>
        </div>
        <div v-if="cadre1">
          <router-link
            to="/fichesinformations/oestroprogestative"
            class="subtitle"
          >
            <p>Oestroprogestative</p>
            <div class="next"><img :src="Right" alt="" /><img alt="" /></div>
          </router-link>
          <router-link
            to="/fichesinformations/microprogestative"
            class="subtitle"
          >
            <p>Microprogestative</p>
            <div class="next"><img :src="Right" alt="" /><img alt="" /></div>
          </router-link>
        </div>
      </div>
      <div class="cadre">
        <div @click="toggleCadre2()" class="title">
          <p>Systèmes Intra Utérin</p>
          <a class="next">
            <img v-if="!cadre2" :src="Right" alt="" /><img
              v-else
              :src="Arrow"
              alt=""
            />
          </a>
        </div>
        <div v-if="cadre2">
          <router-link to="/fichesinformations/diuaucuivre" class="subtitle">
            <p>SIU au cuivre</p>
            <div class="next"><img :src="Right" alt="" /><img alt="" /></div>
          </router-link>
          <router-link
            to="/fichesinformations/siuaulevonorgestrels"
            class="subtitle"
          >
            <p>SIU au levonorgestrel</p>
            <div class="next"><img :src="Right" alt="" /><img alt="" /></div>
          </router-link>
        </div>
      </div>
      <div class="cadre">
        <router-link to="/fichesinformations/anneau" class="title">
          <p>L'anneau oestroprogestatif</p>
          <div class="next"><img :src="Right" alt="" /><img alt="" /></div>
        </router-link>
      </div>
      <div class="cadre">
        <router-link to="/fichesinformations/etonogestrel" class="title">
          <p>L'implant à l'etonogestrel</p>
          <div class="next"><img :src="Right" alt="" /><img alt="" /></div>
        </router-link>
      </div>
      <div class="cadre">
        <router-link to="/fichesinformations/patch" class="title">
          <p>Le patch oestroprogestatif</p>
          <div class="next"><img :src="Right" alt="" /><img alt="" /></div>
        </router-link>
      </div>
      <div class="cadre">
        <router-link
          to="/fichesinformations/leprogestatifinjectable"
          class="title"
        >
          <p>Le progestatif injectable (DEPO PROVERA)</p>
          <div class="next"><img :src="Right" alt="" /><img alt="" /></div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Arrow from "@/assets/images/ArrowDown.png";
import Right from "@/assets/images/ArrowRight.png";
export default {
  name: "Fiches",
  data() {
    return {
      Arrow,
      Right,
      cadre1: false,
      cadre2: false,
    };
  },
  methods: {
    toggleCadre1() {
      this.cadre1 = !this.cadre1;
    },
    toggleCadre2() {
      this.cadre2 = !this.cadre2;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/scss/variables/colors.scss";
@import "@/assets/styles/scss/variables/mixin.scss";

.container {
  margin-top: 37px;
  .cadre {
    width: 100%;
    min-height: 62px;
    margin-bottom: 15px;
    border-radius: 7px;
    color: $black-aigm;
    background-color: $light-pink;
    box-shadow: 0 1px 4px #56090f2b;
    padding-bottom: 2px;
    p {
      font-weight: 500;
      letter-spacing: 0px;
      margin-left: 10px;
      color: $black-aigm;
    }
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 62px;
      a {
        cursor: pointer;
      }
    }
    .subtitle {
      background-color: $middle-pink;
      width: 90%;
      height: 49px;
      margin: 0 0 10px 5%;
      border-radius: 7px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      p {
        color: $black-aigm;
      }
    }
  }
}
</style>
